import axios from "axios";
import { authProvider } from "../src/store/AuthProvider";
import Logout from "./components/Navigation/Logout/Logout";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});
//console.log("baseurl", instance.baseURL)
// const accessToken = sessionStorage.getItem(
//     `${process.env.REACT_APP_ACCESS_TOKEN}`
// );
//console.log("accessToken", accessToken)
const accessToken = sessionStorage.getItem(`token`);
console.log("accessToken", accessToken);
instance.defaults.headers.get["accessToken"] = accessToken;
instance.defaults.headers.post["accessToken"] = accessToken;
instance.defaults.headers.put["accessToken"] = accessToken;

const errorComposer = (error) => {
  const statusCode = error.response ? error.response.status : null;
  //console.log("***** Status Code :", statusCode);

  if (statusCode === 403 || statusCode === 401) {
    // authProvider.logout();
    window.location.replace("/");
    localStorage.clear();
    sessionStorage.clear();
  }
};

instance.interceptors.request.use(function (config) {
  const token = sessionStorage.getItem(`token`);
  config.headers.accessToken = token;

  return config;
});
// Add a response interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    errorComposer(error);
    return Promise.reject(error);
  }
);

export default instance;
